import { render, staticRenderFns } from "./PercentageWall.vue?vue&type=template&id=1a7938cf&scoped=true&"
import script from "./PercentageWall.vue?vue&type=script&lang=js&"
export * from "./PercentageWall.vue?vue&type=script&lang=js&"
import style0 from "./PercentageWall.vue?vue&type=style&index=0&id=1a7938cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7938cf",
  null
  
)

export default component.exports